import { zodResolver } from "@mantine/form";
import { treatmentDataSchema } from "beitary-shared";
import { z } from "zod";

const txFormSchema = treatmentDataSchema;

export type TxFormValues = z.infer<typeof txFormSchema>;

export const rules = zodResolver(txFormSchema);
